import React, { createContext, useContext, useState, useCallback, useEffect, useRef } from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';

const LicenciaContext = createContext();

export const useLicencia = () => useContext(LicenciaContext);

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutos

export const LicenciaProvider = ({ children }) => {
    const [estado, setEstado] = useState(null);         // null | 'ONLINE' | 'WARNING' | 'BLOQUEO'
    const [mensaje, setMensaje] = useState('');
    const [diasGracia, setDiasGracia] = useState(0);
    const [mostrarModal, setMostrarModal] = useState(false);
    const intervalRef = useRef(null);

    const verificarLicencia = useCallback(async () => {
        const token = localStorage.getItem('token');
        if (!token) return;

        try {
            const res = await axios.get(`${config.api_url}/api/status_licencia`, {
                headers: { 'token': token }
            });
            if (res.data) {
                const nuevoEstado = res.data.estado || 'ONLINE';
                setEstado(nuevoEstado);
                setMensaje(res.data.mensaje || '');
                setDiasGracia(res.data.dias_gracia_restantes || 0);
                // Solo mostrar modal si hay algo que advertir (no en ONLINE)
                if (nuevoEstado !== 'ONLINE') {
                    setMostrarModal(true);
                }
            }
        } catch (err) {
            console.error('[LicenciaContext] Error verificando licencia:', err);
        }
    }, []);

    const iniciarPolling = useCallback(() => {
        if (intervalRef.current) return; // ya corre
        intervalRef.current = setInterval(verificarLicencia, POLL_INTERVAL_MS);
    }, [verificarLicencia]);

    const detenerPolling = useCallback(() => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);

    // Limpiar al desmontar
    useEffect(() => () => detenerPolling(), [detenerPolling]);

    const cerrarModal = useCallback(() => setMostrarModal(false), []);

    return (
        <LicenciaContext.Provider value={{
            estado,
            mensaje,
            diasGracia,
            mostrarModal,
            verificarLicencia,
            iniciarPolling,
            detenerPolling,
            cerrarModal,
        }}>
            {children}
        </LicenciaContext.Provider>
    );
};
